import React from 'react';
import { Route } from 'react-router';
import App from './App';
import AppV2 from './AppV2';
import SourcesPage from './components/admin/SourcesPage';
import LeafletMap from './components/maps/LeafletMap';
import Stories from './components/Stories';

export default (
  <Route path="/" component={AppV2}>
    <Route path="v1" component={App} />
    <Route path="*" component={LeafletMap} />
    <Route path="admin/sources" component={SourcesPage} />
    <Route path="maps/leaflet" component={LeafletMap} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js